import React from "react";
import CleanNavBar from "../Layout/CleanNavBar";
import CleanFooter from "../Layout/CleanFooter";

const Careers = () => {
  return (
    <div className="page-wrapper">
      <CleanNavBar />
      <div className="page-content">
        <div className="page-header">
          <h1>Careers at GlobeCab</h1>
        </div>
        <div className="clean-container">
          <div className="content-section">
            <h2>Drive Your Career Forward with GlobeCab</h2>
            <p>
              At GlobeCab, we're revolutionizing urban transportation worldwide. Join our global team of 
              dedicated professionals who are making cities more connected and accessible for everyone.
            </p>
            
            <h3>Why GlobeCab?</h3>
            <ul>
              <li><strong>Impact:</strong> Help millions of people get where they need to go safely</li>
              <li><strong>Flexibility:</strong> Choose your own hours as a driver partner</li>
              <li><strong>Technology:</strong> Work with cutting-edge dispatch and navigation systems</li>
              <li><strong>Global:</strong> Join a diverse team operating in 150+ cities worldwide</li>
              <li><strong>Earnings:</strong> Competitive pay with bonuses and incentive programs</li>
            </ul>
            
            <h3>Open Positions</h3>
            
            <div className="job-listing">
              <h4>Driver Partner - Multiple Cities</h4>
              <p>Join our fleet of professional drivers and earn on your schedule</p>
            </div>
            
            <div className="job-listing">
              <h4>Fleet Operations Manager - London</h4>
              <p>Oversee fleet performance and driver operations in the UK market</p>
            </div>
            
            <div className="job-listing">
              <h4>Customer Service Lead - New York</h4>
              <p>Lead our 24/7 support team ensuring exceptional passenger experience</p>
            </div>
            
            <div className="job-listing">
              <h4>Regional Manager - Tokyo</h4>
              <p>Drive growth and operations across the Japanese market</p>
            </div>
            
            <h3>Ready to Join?</h3>
            <p>
              Send your resume to <a href="mailto:careers@globecab.com">careers@globecab.com</a> with 
              the position title in the subject line. For driver opportunities, visit our driver portal.
            </p>
          </div>
        </div>
      </div>
      <CleanFooter />
    </div>
  );
};

export default Careers;